import qs from 'qs';

import http from './http.service';

const RoomsService = () => {
  const basePath = '/rooms';

  const getRoomsByPropertyId = (model) => http.get(basePath, {
    params: model,
    paramsSerializer: (params) => qs.stringify(params, {
      skipNulls: true,
      arrayFormat: 'brackets',
    }),
  });

  return {
    getRoomsByPropertyId,
  };
};

export default RoomsService;
